__turbopack_context__.v({
  "board": "client-row-visual-module__0HdRmG__board",
  "cellLanded": "client-row-visual-module__0HdRmG__cellLanded",
  "clientRowLand": "client-row-visual-module__0HdRmG__clientRowLand",
  "counter": "client-row-visual-module__0HdRmG__counter",
  "hideNarrow": "client-row-visual-module__0HdRmG__hideNarrow",
  "narrowOnly": "client-row-visual-module__0HdRmG__narrowOnly",
  "pctBadge": "client-row-visual-module__0HdRmG__pctBadge",
  "root": "client-row-visual-module__0HdRmG__root",
  "row": "client-row-visual-module__0HdRmG__row",
  "rowFocused": "client-row-visual-module__0HdRmG__rowFocused",
  "wideOnly": "client-row-visual-module__0HdRmG__wideOnly",
});
